/*
 * File: /src/store/modules/agents.js
 * Created Date: Tuesday November 30th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 30th November 2021 5:52:55 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import agentService from 'src/services/agentService';

const state = {
  agents: undefined,
  agentStatuses: undefined, // All statuses
};

const getters = {
  getAgent: state => id => {
    if (!state.agents || !state.agents.filter || state.agents.length === 0)
      return undefined;
    const agent = state.agents.filter(a => +a.id === +id);
    if (agent && agent.length > 0) {
      return agent[0];
    }
    return undefined;
  },
  getAgents: state  => {
    return state.agents;
  },
  getAgentStatuses: state  => {
    return state.agentStatuses;
  },
};

const actions = {
 fetchAgents({ commit }) {
   if (state.agents === undefined) {
     return agentService
      .getAgents(0, 1000)
      .then(response => {
        commit('setAgents', response);
        // For now just alert if we are in a breaking state.
        if (response.len === 1000) {
          console.error("We have more agents than the system can handle: 1000");
        }
        return response;
      });
   }
  },
  unloadAgents({ commit }) {
    commit('setAgents', undefined);
  },
 fetchAgentStatuses({ commit }) {
   if (state.agentStatuses === undefined) {
     return agentService
      .getConfig()
      .then(response => {
        commit('setAgentStatuses', response);
        return response;
      });
   }
  },
  unloadAgentStatuses({ commit }) {
    commit('setAgentStatuses', undefined);
  },
};

const mutations = {
  setAgents(state, agents) {
    state.agents = Object.assign([], agents);
  },
  removeAgent(state, agentId) {
    state.agents = state.agents.filter(d => d.id !== agentId);
  },
  setAgentStatuses(state, statuses) {
    state.agentStatuses = Object.assign([], statuses);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
